import { CommonService } from "./../../services/common.service";
import { FileService } from "./../../services/file.service";
import { ManageService } from "./../../services/manage.service";
import {
  AnnuityViewModel,
  AnnuityListViewModel,
} from "./../../models/annuity-view.model";
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  ComponentFactoryResolver,
  ElementRef,
} from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Sort } from "@angular/material/sort";
import { SubscriptionModel } from "../../models/common.model";
// tslint:disable-next-line:import-blacklist
import { Subject } from "rxjs";
import { TablefilterMultiplePipe } from "../../shared/pipes/tablefilter-multiple.pipe";
import { AuthService } from "../../services/auth.service";
import { CurrentUserModel } from "../../models/account-ledger.model";
import { TenantResponse } from "../../models/check-out.model";
import { ConfigureEndUserComponent } from "./configure-end-user/configure-end-user.component";
import { isNullOrUndefined } from '../../shared/tools.collections';
import { NgProgressService } from "../../services/ngProgress.service";
import { finalize, takeUntil } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";
import { MigrateToNCEComponent } from "../../popup-collection/migrate-to-nce/migrate-to-nce.component";
import { MatDialog } from "@angular/material/dialog";
import { WGSListTableViewModel, WGSSubscriptionDetail, WGSSubscriptionDetailsItemViewModel } from "../../models/wgs.model";
import { AdobeService } from "../../services/adobe.service";
import { IAdobeCustomesForQuoting } from "../../models/amp.model";
import { DDAIService } from "../../services/dd-ai.service";
import { ADKDetailsViewModel } from "../../models/adk-details-view.model";

@Component({
  selector: "app-manage-annuities",
  templateUrl: "./manage-annuities.component.html",
  styleUrls: ["./manage-annuities.component.css"],
})
export class ManageAnnuitiesComponent implements OnInit, OnDestroy {
  logoURL = "";
  longDescription = "";
  moreInfo = "";
  totalEndUser = 0;
  totalPending = 0;
  totalCancelled = 0;

  hideSideBar = false;
  narrowMode = false;
  loadContent = false;
  finishLoading = true;
  showDownload = true;
  showRest = true;
  model: AnnuityListViewModel;
  annuities: AnnuityViewModel[];

  sortedData: AnnuityViewModel[] = [];
  displayedColumns: string[] = [];
  AMPCodeCheckingTableColumns = ['customerName', 'manage']
  dataSource: MatTableDataSource<AnnuityViewModel>
  AMPCodeCheckingDataSource: MatTableDataSource<IAdobeCustomesForQuoting>
  // export excel
  url: string;
  keyword: string;
  expiryStartDate: string;
  expiryEndDate: string;

  // params
  programType = "";
  programName = "";
  pageView = "PROGRAMS";
  expiryStart = "";
  expiryEnd = "";

  // Pagination
  itemsPerPage = 10;
  totalItems = 0;
  showPager = false;

  // search
  searchField: string;

  WGSHardwareSubSearchField: string;
  WGSElectronicSubSearchField: string;

  firstColumnName = "END USER NAME";
  nextBillColumnName =  "NEXT BILL";
  amountColumnName =  "AMOUNT(Ex)";

  hasEmptyFilterResult = false;

  filterResultArr: any;
  filterDefaultResultArr: any;

  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  currentUserModel: CurrentUserModel;
  public WGSTableListItems: WGSListTableViewModel[];
  public activeTotal = '0';
  public isWGSItemLoading = true;

  public WGSHardwareSubs: WGSListTableViewModel[] = [];
  public WGSElectronicSubs: WGSListTableViewModel[] = [];
  public searchSubscription = '';
  wgsSubscriptionPage:boolean = false;
  public WGSdetails: ADKDetailsViewModel;
  public isSubscriptionResponseLoading = false;

  private AMPPendingTransactions: any[] = [];

  @ViewChild("entry", { read: ViewContainerRef })
  entry: ViewContainerRef;

  @ViewChild('dynamicInsert', { read: ViewContainerRef }) dynamicInsert: ViewContainerRef;
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  public tenantExpiryOptionList: any = [
    { name: 'All', value: 'all' },
    { name: 'Upcoming Renewals (90 Days)', value: 'exp90' },
    { name: 'Open Renewals (30 Days)', value: 'exp30' },
    { name: 'Pending Transactions', value: 'pt' },
  ];
  public filterExpiryModel = 'all'

  constructor(
    private router: Router,
    private activatedroute: ActivatedRoute,
    private manageService: ManageService,
    private fileService: FileService,
    private commonService: CommonService,
    private ngProgress: NgProgressService,
    private adobeService: AdobeService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private dialog: MatDialog,
    public authService: AuthService,
    public ddaiService: DDAIService
  ) { }

  loadComponent(tenantId: string, tab: string) {

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ConfigureEndUserComponent);
    this.dynamicInsert.clear();
    const dynamicComponent = <ConfigureEndUserComponent>this.dynamicInsert.createComponent(componentFactory).instance;
    dynamicComponent.tenantId = tenantId;
    dynamicComponent.tab = tab;

  }

  clearComponent() {
    if (this.dynamicInsert) {
      this.dynamicInsert.clear();
    }
  }

  matSortData(sort: Sort) {
    const data = this.annuities.slice();
    if (!sort.active || sort.direction === "") {
      this.dataSource.data = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "annuityId":
          return compare(
            a.annuityId.toLowerCase(),
            b.annuityId.toLowerCase(),
            isAsc
          );
        case "endUserName":
          return compare(
            a.endUserName.toLowerCase(),
            b.endUserName.toLowerCase(),
            isAsc
          );
        case "programType":
          return compare(
            a.programType.toLowerCase(),
            b.programType.toLowerCase(),
            isAsc
          );
        case "nextOrderNo":
          return compare(
            a.nextOrderNo.toLowerCase(),
            b.nextOrderNo.toLowerCase(),
            isAsc
          );
        case "currCustomerRef":
          return compare(
            a.currCustomerRef.toLowerCase(),
            b.currCustomerRef.toLowerCase(),
            isAsc
          );
        case "lastBillingDate":
          return compare(
            this.dateFormat(a.lastBillingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            this.dateFormat(b.lastBillingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            isAsc
          );
        case "billingDate":
          return compare(
            this.dateFormat(a.billingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            this.dateFormat(b.billingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            isAsc
          );
        case "lastBillingAmount":
          return compare(
            parseFloat(a.lastBillingAmount),
            parseFloat(b.lastBillingAmount),
            isAsc
          );
        case "totalAmount":
          return compare(
            parseFloat(a.totalAmount),
            parseFloat(b.totalAmount),
            isAsc
          );
        case "status":
          return compare(
            a.status.toLowerCase(),
            b.status.toLowerCase(),
            isAsc
          );
        case "anniversaryDate":
          return compare(
            +this.commonService.getDate(a.anniversaryDate),
            +this.commonService.getDate(b.anniversaryDate),
            isAsc
          );
        case "autoRenewal":
          return compare(
            a.autoRenew,
            b.autoRenew,
            isAsc
          );
        case "openRenewal":
          return compare(
            this.isAnnuityOpenRenewal(a).toString(),
            this.isAnnuityOpenRenewal(b).toString(),
            isAsc
          );
        case "pendingTransactions":
          return compare(
            (a?.isAMPPendingTransaction).toString(),
            (b?.isAMPPendingTransaction).toString(),
            isAsc
          );
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedData);
  }

  sortData(sort: Sort) {
    const data = this.annuities.slice();
    if (!sort.active || sort.direction === "") {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "annuityId":
          return compare(
            a.annuityId.toLowerCase(),
            b.annuityId.toLowerCase(),
            isAsc
          );
        case "endUserName":
          return compare(
            a.endUserName.toLowerCase(),
            b.endUserName.toLowerCase(),
            isAsc
          );
        case "programType":
          return compare(
            a.programType.toLowerCase(),
            b.programType.toLowerCase(),
            isAsc
          );
        case "nextOrderNo":
          return compare(
            a.nextOrderNo.toLowerCase(),
            b.nextOrderNo.toLowerCase(),
            isAsc
          );
        case "currCustomerRef":
          return compare(
            a.currCustomerRef.toLowerCase(),
            b.currCustomerRef.toLowerCase(),
            isAsc
          );
        case "lastBillingDate":
          return compare(
            this.dateFormat(a.lastBillingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            this.dateFormat(b.lastBillingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            isAsc
          );
        case "billingDate":
          return compare(
            this.dateFormat(a.billingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            this.dateFormat(b.billingDate.toLowerCase())
              .split("-")
              .reverse()
              .join("-"),
            isAsc
          );
        case "lastBillingAmount":
          return compare(
            parseFloat(a.lastBillingAmount),
            parseFloat(b.lastBillingAmount),
            isAsc
          );
        case "totalAmount":
          return compare(
            parseFloat(a.totalAmount),
            parseFloat(b.totalAmount),
            isAsc
          );
        case "status":
          return compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
        default:
          return 0;
      }
    });
  }

  ngOnInit() {
    this.ngProgress.start();
    // Initialize the narrow mod
    this.narrowMode = false;
    this.hideSideBar = false;
    this.showDownload = true;

    this.authService.getLoginInfo().subscribe(
      (res: CurrentUserModel) => {       
        this.currentUserModel = res;       
      },
      (error: any) => {
        console.error(error);
      }
    );

    this.isWgsSubscriptionPage();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isWgsSubscriptionPage();
      }
    });
    this.activatedroute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      setTimeout(() => {
        if (!$('#managecsp').length && !$('#addWGSProduct').length && !$('#manageamp').length) {
          $('#levelOne').animate({ scrollLeft: 0 }, 400);
        }
      }, 100)

    },
      (error: any) => {
        console.error(error);
      });

    this.manageService.currentAnnuityWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((watch: TenantResponse) => {
        this.activatedroute.paramMap.pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res) => {
            this.loadContent = false;
            this.programType = res.get("programType");
            switch (this.programType) {
              case 'CSP':
                this.displayedColumns = ['hasPaymentSetup', 'columnName', 'autoRenew', 'euPortalAccess', 'manage', 'migrate'];
                break;
              case 'KASP':
                this.displayedColumns = ['hasPaymentSetup', 'columnName', 'currCustomerRef', 'totalAmount', 'euPortalAccess', 'manage'];
                break;
              case 'VDC':
                  this.displayedColumns = ['columnName', 'lastBillingDate', 'totalAmount', 'manage'];
                  break;
              case 'WGS':
                this.displayedColumns = ['desc', 'userCount', 'status', 'manageBtn'];
                break;
              case 'AMP':
                this.displayedColumns =  ['hasPaymentSetup', 'columnName', 'anniversaryDate', 'autoRenew', 'openRenewal', 'pendingTransactions', 'manage'];
                this.firstColumnName = "CUSTOMER";
                break;
              case 'SPLA':

                this.firstColumnName = "ENROLMENT NO";
                break;
              case 'SKBAK':
                this.nextBillColumnName = "PREVIOUS INVOICE";
                this.amountColumnName = "PREVIOUS AMOUNT(Ex)";
                break;
              case 'SKPLAT':
                this.nextBillColumnName = "PREVIOUS INVOICE";
                this.amountColumnName = "PREVIOUS AMOUNT(Ex)";
                break;
              case 'CITRIXCSP':
                this.firstColumnName = "ENROLMENT NO";
                break;
            }

            const vendorDetais = JSON.parse(localStorage.getItem("subscriptionVendor"));
            if (vendorDetais.length) {
              const filteredVendor = vendorDetais.filter((x) => x.programType === this.programType);
              if (filteredVendor.length) {
                this.programName = filteredVendor[0].programName;
              }
            }
            this.getSubscriptionOrders();
          }, (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }, (error: any) => {
        console.error(error);
        this.loadContent = true;
      }
      );

    this.manageService.currentBillingInfo
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getSubscriptionOrders();
        }
      });

    this.manageService.getOrRefreshSubscriptionOrderSubject.asObservable()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((refresh) => {
        if (refresh) {
          this.getSubscriptionOrders();
        }
      });

    if (
      this.router.url !==
      `/manageSubscriptions/manageAnnuities/${this.programType}`
    ) {
      this.narrowMode = true;
      if (this.router.url.includes('manageAMPReseller')) {
        this.hideSideBar = true;
      } else {
        this.hideSideBar = false;
      }
      this.loadContent = true; // set to true to avoid load two loading screen at the same time
    }
    // Link to create new csp tenant
    if (
      this.router.url ===
      "/manageSubscriptions/manageAnnuities/CSP/createEndUser"
    ) {
      this.programName = "Microsoft CSP";
      this.addNewEndUser();
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          event.url ===
          `/manageSubscriptions/manageAnnuities/${this.programType}`
        ) {
          this.narrowMode = false;
          this.hideSideBar = false;
        }
      }
    });

    this.manageService.currentConfigureEndUserStatus.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res.status) {
        this.loadComponent(res.tenantId, res.tab);
      } else {
        this.clearComponent();
      }
    });

    this.ngProgress.done();
  }

  /*
  * this function is used for the add and manage sbscription page
  */
  isWgsSubscriptionPage(): boolean {
    const manageSubscriptionUrl = '/manageSubscriptions/manageAnnuities/WGS/subscription/';
    const addSubscriptionUrl = '/manageSubscriptions/manageAnnuities/WGS/AddWGSProducts';
    const confirmProducts = '/manageSubscriptions/manageAnnuities/WGS/AddWGSProducts/ConfirmProducts';
  
    const urlSegments = this.router.url.split('/');
    const subscriptionUrlValue = this.router.url.replace(urlSegments[urlSegments.length - 1],'')
    //Here it's check the value it's manage container or add container If any one if available then it's take this => row, overflow-x classes
    this.wgsSubscriptionPage = ((subscriptionUrlValue === manageSubscriptionUrl) || (this.router.url === addSubscriptionUrl) || (this.router.url === confirmProducts)) ? true : false;    
    return this.wgsSubscriptionPage;
  }

  getSubscriptionOrders(): void {   
    if (this.programType === "WGS") {
      this.manageService.refetchWGSItemsView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
        this.getWGSubscriptionOrders();
      });
      this.manageService.updateWGSdetailView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail: WGSSubscriptionDetail) => {
        if (!this.commonService.isEmpty(detail)) {
          this.setWGSDetail(detail);
        }
      });
      this.getWGSubscriptionOrders();
    } else {
      this.getOtherSubscriptionOrders();
    }
  }

  private getOtherSubscriptionOrders() {
   
    this.manageService
      .getSubscriptionOrders(this.pageView, this.programType, this.expiryStart, this.expiryEnd)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: AnnuityListViewModel) => {       
        this.showDownload = true;
        this.model = value;
        this.loadContent = true;
        this.moreInfo = null;

        // adobe customers for quoting
        if (this.programType == 'AMP') {
          this.adobeService.GetAdobeTenants_ForQuotes()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: result => {
              const customers = result as IAdobeCustomesForQuoting[]
              if (customers?.length) {
                this.AMPCodeCheckingDataSource = new MatTableDataSource(customers);
                this.adobeService.setCurrentAMPCustomersForQuotes(customers)
              }
            },
            error: (error: string) => this.commonService.implementToast(error, "Error"),
          })
        }

        if (
          value != null &&
          value.orders != null &&
          value.orders.length > 0
        ) {
          this.annuities = value.orders;
          this.manageService.monitorCurrentAnnuityList(this.annuities)
          this.annuities.forEach((annuity) => {
            annuity.priceLoadingStatus = false;
          });
          if (this.programType === "CSP") {
            this.manageService.GetTenantAzureUsageTotals().subscribe(
              (res: any) => {
                this.annuities.forEach((annuity) => {
                  annuity.priceLoadingStatus = true;
                  if (
                    res.filter((x) => x.tenantId === annuity.annuityId)
                      .length > 0
                  ) {
                    annuity.totalAmount = (
                      this.commonService.toNumber(annuity.totalAmount) +
                      this.commonService.toNumber(
                        res.filter((x) => x.tenantId === annuity.annuityId)[0]
                          .total
                      )
                    ).toString();
                  }
                });
              },
              (error: any) => {
                console.error(error);
                this.loadContent = true;
              }
            );
          } else {
            this.annuities.forEach((annuity) => {
              annuity.priceLoadingStatus = true;
            });
          }         
          if (this.programType === 'AMP') {           
            this.annuities.sort((a, b) => (+this.commonService.getDate(a.anniversaryDate) - +this.commonService.getDate(b.anniversaryDate)) || a.endUserName.localeCompare(b.endUserName));

            this.adobeService.getCurrentAMPResellerId.pipe(takeUntil(this.ngUnsubscribe)).subscribe(resellerId => {
                if (resellerId) {
                  this.adobeService.getAMPLicensesPendingPartnerOrderNotification(resellerId)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe({
                      next: result => {
                        this.AMPPendingTransactions = result?.items
                        this.annuities.forEach(a => {
                         a.isAMPPendingTransaction = this.AMPPendingTransactions.map((a => a?.customerId)).includes(a?.annuityId);
                        });
                        this.manageService.monitorCurrentAnnuityList(this.annuities)
                      },
                      error: (error: string) => this.commonService.implementToast(error, "Error"),
                    })
                }
            });           
          }

          this.sortedData = this.annuities.slice();
          this.totalItems = this.annuities.length;

          this.totalEndUser = this.annuities.length;
          this.totalPending = this.annuities.filter(
            (x) => x.status.indexOf("Pending") !== -1
          ).length;
          this.totalCancelled = this.annuities.filter(
            (x) => x.status.indexOf("Cancelled") !== -1
          ).length;
          this.dataSource = new MatTableDataSource(this.sortedData);
        } else {
          this.annuities = [];
          this.sortedData = [];
          this.dataSource = new MatTableDataSource(this.sortedData);
          this.totalItems = 0;
          this.showDownload = false;
        }

        // this.showPager = this.totalItems > this.itemsPerPage ? true : false;
        this.longDescription = value.longDescription;

        if (!isNullOrUndefined(value.programLogo)) {
          this.logoURL = value.programLogo;
        }
        if (!isNullOrUndefined(value.moreInfo)) {
          this.moreInfo = value.moreInfo;
        }
        // this.commonService.applyScrollFixedHeader(this.parentWrapper);
      }, (error: any) => {
        console.error(error);
        this.loadContent = true;
      }
      );
  }

  private getWGSubscriptionOrders() {   
    // WGS Description and logo
    this.manageService
    .getSubscriptionOrders(this.pageView, this.programType, this.expiryStart, this.expiryEnd)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((value: AnnuityListViewModel) => {
      this.moreInfo = null;
      this.longDescription = value.longDescription;

        if (!isNullOrUndefined(value.programLogo)) {
          this.logoURL = value.programLogo;
        }
        if (!isNullOrUndefined(value.moreInfo)) {
          this.moreInfo = value.moreInfo;
        }
    });
    this.manageService.getCurrentWGSContractResellerId
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resellerId => {
        if (resellerId) {
          this.isSubscriptionResponseLoading = true;
          this.manageService.getADKDetails(resellerId, this.programType)
          .pipe(
            finalize(() => {
              this.isSubscriptionResponseLoading = false;
            }),
            takeUntil(this.ngUnsubscribe)
          )
            .subscribe((value: ADKDetailsViewModel) => {
              this.WGSdetails = value;
              this.manageService.monitorCSPTenantDetails(this.WGSdetails.customer);
              this.manageService.monitorDetailsChange(this.WGSdetails);
            },
              (error: any) => {
                console.info(error);
              });

          this.manageService
            .getWGSItemsView(resellerId)
            .subscribe((model: WGSSubscriptionDetailsItemViewModel) => {
              this.activeTotal = '0';
              this.WGSTableListItems = model.subscriptions.map(view => ({
                subscriptionListView: view,
                subscriptionDetailView: null
              } as WGSListTableViewModel ));



              this.loadContent = true;            
              this.isWGSItemLoading = false;

              this.sortedData = this.WGSTableListItems.map(i => ({
                endUserName: i?.subscriptionListView?.out_subscription_id,
                totalAmount:  i?.subscriptionListView?.out_amount
              } as AnnuityViewModel )).slice();
              this.totalItems = this.WGSTableListItems.length;
            
              this.WGSHardwareSubs = this.WGSTableListItems
                .filter(x => x.subscriptionListView?.out_parent_subscription !== 'DEFAULT');
              
              this.WGSElectronicSubs = this.WGSTableListItems
                .filter(x => x.subscriptionListView?.out_parent_subscription == 'DEFAULT');

              model.subscriptions.forEach((s, index) => {
                this.activeTotal = (this.commonService.toNumber(this.activeTotal) + this.commonService.toNumber(s.out_amount)).toString();
                this.GetWGSSubscriptionDetail(resellerId, s?.out_subscription_id.toUpperCase(), index)
              });
            },
              (error: any) => {
                console.error(error);
              });
        }
        
      })
  }

  private GetWGSSubscriptionDetail(resellerId: string, subscriptionId: string, index: number) {
    this.manageService.GetWGSSubscriptionDetail(resellerId, subscriptionId.toUpperCase())
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail: WGSSubscriptionDetail) => {
        if (!this.commonService.isEmpty(detail)) {
          this.setWGSDetail(detail);
        }
      })
  }

  private setWGSDetail(detail: WGSSubscriptionDetail) {
    const index = this.WGSTableListItems.findIndex(x => x.subscriptionListView?.out_subscription_id === detail?.subscriptionContractId);
    if (index >= 0) {
      this.WGSTableListItems[index].subscriptionDetailView = detail;

      if (this.WGSTableListItems[index].subscriptionDetailView.subscriptionStatus == 'Cancelled') {
        this.WGSTableListItems.splice(index, 1);
        this.WGSHardwareSubs = this.WGSTableListItems
          .filter(x => x.subscriptionListView?.out_parent_subscription !== 'DEFAULT');
        
        this.WGSElectronicSubs = this.WGSTableListItems
          .filter(x => x.subscriptionListView?.out_parent_subscription == 'DEFAULT');
      }
    }
  }

  exportExcelForAnnuities(): void {
    this.finishLoading = false;
    this.ngProgress.start();
    this.keyword = this.programType;

    this.manageService
      .exportExcelForAnnuities(this.keyword, this.pageView, "", "")
      .subscribe(
        (data: any) => {
          const fileName = `Annuity Information ${this.currentUserModel.accountId}.xlsx`;

          this.fileService.saveAsExcelFile(data, fileName);
          this.finishLoading = true;
          this.ngProgress.done();
        },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
      );
  }

  public exportNCEMigrationReport(annuity: AnnuityViewModel): void {
    this.finishLoading = false;
    this.ngProgress.start();

    this.manageService
      .exportNCEMigrationReport(annuity.annuityId)
      .subscribe(
        (data: any) => {
          const fileName = `Migration Report ${annuity.annuityId}.xlsx`;

          this.fileService.saveAsExcelFile(data, fileName);
          this.finishLoading = true;
          this.ngProgress.done();
        },
        (error: any) => {
          this.commonService.implementToast(error, 'Error');
          this.finishLoading = true;
          this.ngProgress.done();
        }
      );
  }

  public manageRedirect(annuity: any, detailsView: string): void {
    if (this.narrowMode) {
      this.showRest = false;
      $('app-manage-csp-details').hide("slide", { direction: "left" }, 400).promise().then(() => {
        this.showRest = true;
        this.navToTenantDetail(annuity, detailsView);
        $('app-manage-csp-details').show("slide", { direction: "left" }, 400);
      });
    } else {
      this.narrowMode = true;
      this.navToTenantDetail(annuity, detailsView);
    }
  }

  private navToTenantDetail(annuity: any, detailsView: string) {
    let subEndUserView;
    switch (detailsView) {
      case 'WGSDetails':
        subEndUserView = 'manage'
        break;
      default:
        subEndUserView = detailsView
    }
    if (SubscriptionModel.VendorSubscriptionType.includes(this.programType)) {
      if (annuity.status === "Pending Billing Information") {
        this.router.navigate(
          [`${subEndUserView}/${annuity.annuityId}/EditEndUser`],
          { relativeTo: this.activatedroute }
        );
      } else {
        this.router.navigate([`${subEndUserView}/${annuity.annuityId ? annuity.annuityId : annuity.tenantId}`], {
          relativeTo: this.activatedroute,
        })
      }
    }  else if(this.programType == 'SKBAK' || this.programType == 'SKPLAT' ){
      this.router.navigate(
        [
          `${subEndUserView}/${annuity.annuityId}/${annuity.nextOrderNo}`
        ],
        {
          relativeTo: this.activatedroute,
        }
      );
    } 
    else {
      this.router.navigate(
        [
          `${subEndUserView}/${annuity.annuityId}/${annuity.nextOrderNo}/${annuity.vendorAgreementNo ? annuity.vendorAgreementNo : 'null'}/${annuity.nextOrderSuffix ? annuity.nextOrderSuffix : "OrderSuffix"}`
        ],
        {
          relativeTo: this.activatedroute,
        }
      );
    }
  }

  isActive(annuityId: string): boolean {
    return this.router.url.includes(annuityId);
  }

  addNewEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["createEndUser"], {
      relativeTo: this.activatedroute,
    });
  }

  public editAMPReseller(): void {
    this.narrowMode = true;
    this.hideSideBar = true;
    this.router.navigate(["manageAMPReseller"], {
      relativeTo: this.activatedroute,
    });
  }

  public addAMPNewEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["createAMPCustomer"], {
      relativeTo: this.activatedroute,
    });
  }

  public addWGNewEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["createWatchGuardEndUser"], {
      relativeTo: this.activatedroute,
    });
  }

  addKaspNewEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["createKaspEndUser"], {
      relativeTo: this.activatedroute,
    });
  }

  addCirrusNewEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["createCirrusEndUser"], {
      relativeTo: this.activatedroute,
    });
  }

  associateExistingEndUser(): void {
    this.narrowMode = true;
    this.router.navigate(["associateExistingEndUser"], {
      relativeTo: this.activatedroute,
    });
  }

  associateAdobeCustomer(): void {
    this.narrowMode = true;
    this.router.navigate(["associateAdobeCustomer"], {
      relativeTo: this.activatedroute,
    });
  }

  public migrateVIPAMP(): void {
    this.narrowMode = true;
    this.router.navigate(["VIPMarketPlaceMigrations"], {
      relativeTo: this.activatedroute,
    });
  }
  public bulkMigrateVIPAMP(): void {
    this.narrowMode = true;
    this.router.navigate(["VIPMarketPlaceBulkMigrations"], {
      relativeTo: this.activatedroute,
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl("/manageSubscriptions");
  }

  dateFormat(date: any) {
    const month = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };
    let formatedDate = date.split("-");
    formatedDate[1] = month[formatedDate[1]];
    formatedDate = formatedDate.join("-");
    return formatedDate;
  }

  onMatChange() {
    this.dataSource.filter = this.searchField.trim().toLowerCase();
    //this.WGSTableListItems.filter = this.searchField.trim().toLowerCase();
  }

  filterWGSHardwareSubs(){
    this.WGSHardwareSubs = this.WGSTableListItems.filter(x => x.subscriptionListView.out_parent_subscription !== 'DEFAULT');

    if (this.WGSHardwareSubSearchField?.length > 0) {
      this.WGSHardwareSubs = this.WGSHardwareSubs.filter(x => (
        x.subscriptionListView?.out_stock_code.toLowerCase().includes(this.WGSHardwareSubSearchField.toLowerCase()) ||
        x.subscriptionListView?.out_stk_description.toLowerCase().includes(this.WGSHardwareSubSearchField.toLowerCase()) ||
        x.subscriptionListView?.out_subscription_id.toLowerCase().includes(this.WGSHardwareSubSearchField.toLowerCase())
      ));
    }
  }

  filterWGSElectronicSubs() {    
    this.WGSElectronicSubs = this.WGSTableListItems.filter(x => x.subscriptionListView.out_parent_subscription == 'DEFAULT');

    if (this.WGSElectronicSubSearchField?.length > 0) {
      this.WGSElectronicSubs = this.WGSElectronicSubs.filter(x => (
        x.subscriptionListView?.out_stock_code.toLowerCase().includes(this.WGSElectronicSubSearchField.toLowerCase()) ||
        x.subscriptionListView?.out_stk_description.toLowerCase().includes(this.WGSElectronicSubSearchField.toLowerCase()) ||
        x.subscriptionListView?.out_subscription_id.toLowerCase().includes(this.WGSElectronicSubSearchField.toLowerCase())
      ));
    }
  }


 
  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(
      this.sortedData,
      [
        "endUserName",
        "currCustomerRef",
        "billingDate",
        "totalAmount",
        "status",
      ],
      this.searchField
    );

    if (this.filterResultArr.length === 0 && this.searchField !== "") {
      this.hasEmptyFilterResult = true;
    } else {
      this.hasEmptyFilterResult = false;
    }
    // this.commonService.applyScrollFixedHeader(this.parentWrapper);
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  public openNCEMigrationPopup(annuity: AnnuityViewModel = null): void {
    this.dialog.open(MigrateToNCEComponent, {
      width: '600px',
      data: { annuity }
    })
      .afterClosed()
      .subscribe(result => {
        if (result && result.action === 'CloseAndRefresh') {
          this.getSubscriptionOrders();
        }
      });
  }

  public showAllMigrationButton(): boolean {
    // even the migration is completed, it will still be in progress from backend
    return !this.sortedData.every(annuity => annuity?.containsLegacy == 'N' )
  }

  public manageWGSubscription(subscription: WGSSubscriptionDetail): void {
    this.narrowMode = true;
    this.manageService.WGSSubscriptionDetail.next(subscription);
    this.router.navigate(['subscription/' + subscription?.subscriptionContractId], { relativeTo: this.activatedroute });
  }

  public getWGSProductList(): void {
    this.narrowMode = true;
    this.router.navigate(['AddWGSProducts'], { relativeTo: this.activatedroute });
    // $('#levelOne').animate({ scrollLeft: 1235 }, 400);
    // setTimeout(() => {
    //   if (!$('#managecsp').length) {
    //     $('#levelOne').animate({ scrollLeft: 250 }, 400);
    //   }
    // }, 100)
  }

  public openBulkAssociatePopup() {
    this.narrowMode = true;
    this.router.navigate(["bulkAssociate"], {
      relativeTo: this.activatedroute,
    });
  }
  public openBulkOrdersPopup() {
    this.narrowMode = true;
    this.router.navigate(["bulkOrder"], {
      relativeTo: this.activatedroute,
    });
  }

  public openBulkTransferPopup() {
    this.narrowMode = true;
    this.router.navigate(["bulkTransfer"], {
      relativeTo: this.activatedroute,
    });
  }

  public filterExpiry(e): void {

    if (e?.value == 'exp90') {
      const today = new Date();
      this.dataSource = new MatTableDataSource([ ...this.sortedData ].filter(annuity => {
        const date = this.commonService.getDate(annuity?.anniversaryDate);
        const diffTime = Math.abs(+today - +date);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return (diffDays <= 90);
      }));
    } else if (e?.value == 'exp30') {
      this.dataSource = new MatTableDataSource([ ...this.sortedData ].filter(annuity => this.isAnnuityOpenRenewal(annuity)));
    } else if (e?.value == 'pt') {
      this.dataSource = new MatTableDataSource([ ...this.sortedData ].filter(annuity => annuity?.isAMPPendingTransaction));
    } else if (e?.value == 'all') {
      this.dataSource = new MatTableDataSource(this.sortedData);
    }
  }

  public isAnnuityOpenRenewal(annuity: AnnuityViewModel): boolean {
    const today = new Date();
    const date = this.commonService.getDate(annuity?.anniversaryDate);
    const diffTime = Math.abs(+today - +date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return (diffDays <= 30);
  }

  public showAnniversaryDate(annuity: AnnuityViewModel): boolean {
    const ToDate = new Date();
    const anniversaryDate = this.commonService.getDate(annuity?.anniversaryDate)
    return (new Date(anniversaryDate).getTime() >= ToDate.getTime())
  }

    shouldShowRow(sub: any): boolean {
    // Access properties of the 'sub' object here to determine visibility
    return sub?.subscriptionDetailView?.subscriptionStatus !== 'Cancelled';
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
